import { Box } from '@mui/material';
import Panel from './Panel';

const Fullscreen = () => (
  <Box sx={{ height: '100%', p: 4, 'overflow-y': 'scroll' }}>
    <Panel hideCloseButton />
  </Box>
);

export default Fullscreen;
